import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '@/store';
import { useLocale } from '@/hooks/useLocale';
import qubitLogoSmall from '@/assets/q.svg';
import qubitLogo_en from '@/assets/logo-QuBit.svg';
import qubitLogo_zh from '@/assets/logo-QuBit-zh.svg';
import qubitLogo_zh_tw from '@/assets/logo-QuBit-zh-tw.svg';

interface LogoProps {
    collapsed?: boolean;
}

const Logo: React.FC<LogoProps> = observer(({ collapsed }) => {
    const { ConfigStore } = useStore();
    const { currentLang } = useLocale();
    
    // Select logo based on current language
    const qubitLogo = currentLang === 'zh-CN' 
        ? qubitLogo_zh 
        : currentLang === 'zh-TW' 
        ? qubitLogo_zh_tw 
        : qubitLogo_en;

    return (
        // <div className="flex items-center gap-2 px-4 py-3">
        //     <img 
        //         src={qubitLogo} 
        //         alt="logo" 
        //         className="w-8 h-8"
        //         style={{ 
        //             filter: `drop-shadow(0 0 2px ${ConfigStore.currentPresetColor})`
        //         }} 
        //     />
        //     {!collapsed && (
        //         <span 
        //             className="text-lg font-semibold truncate transition-colors"
        //             style={{ color: ConfigStore.currentPresetColor }}
        //         >
        //            {getGlobalConfig('AdminName')}
        //         </span>
        //     )}
        // </div>
        <div className={`w-full flex ${collapsed ? 'items-center justify-center' : 'items-start'} px-4 py-3`}>
            <div className={`flex justify-center items-center ${collapsed ? 'w-18 py-3' : 'w-50 px-4 py-3'}`}>
                <img 
                    src={collapsed ? qubitLogoSmall : qubitLogo} 
                    alt="logo" 
                    className={`transition-all duration-300 ${collapsed ? 'h-6 w-6 object-cover' : 'h-6 w-auto'}`}
                    style={{ 
                        filter: `drop-shadow(0 0 2px ${ConfigStore.currentPresetColor})`,
                        objectPosition: collapsed ? 'left' : 'left'
                    }} 
                />
            </div>
            {/* <div className={`flex justify-center items-center px-4 py-3 ${collapsed ? 'w-12' : 'w-full'}`}>
                <img 
                    src={qubitLogo} 
                    alt="logo" 
                    className={`transition-all duration-300 ${collapsed ? 'h-6 w-6 object-cover' : 'h-12 w-auto'}`}
                    style={{ 
                        filter: `drop-shadow(0 0 2px ${ConfigStore.currentPresetColor})`
                    }} 
                />
            </div> */}
        </div>
    );
});

export default Logo;
